const routes = [
    {
        path: '/area_cliente_adm/configuracoes/index',
        alias: '/area_cliente_adm/configuracoes',
        component: () => import('../views/Aparencia')
    },
    {
        path: '/area_cliente_adm/configuracoes/usuarios',
        component: () => import('../views/Usuarios')
    }
]

export default routes
